module.exports = {
  Argentina: {
    M: "CUIT",
    F: "CUIT",
  }, // Argentina
  "Bolivia, Plurinational State of": {
    M: "NIT",
    F: "NIT",
  }, // Bolivia, Plurinational State of
  Brazil: {
    M: "CPF",
    F: "CPF",
  }, // Brazil
  Canada: {
    M: "SIN",
    F: "SIN",
  }, // Canada
  Chile: {
    M: "RUT",
    F: "RUT",
  }, // Chile
  Colombia: {
    M: "NIT",
    F: "NIT",
  }, // Colombia
  "Costa Rica": {
    M: "NITE",
    F: "NITE",
  }, // Costa Rica
  Cuba: {
    M: "NIT",
    F: "NIT",
  }, // Cuba
  "Dominican Republic": {
    M: "RNC",
    F: "RNC",
  }, // Dominican Republic
  Ecuador: {
    M: "RUC",
    F: "RUC",
  }, // Ecuador
  "El Salvador": {
    M: "NIT",
    F: "NIT",
  }, // El Salvador
  Guatemala: {
    M: "NIT",
    F: "NIT",
  }, // Guatemala
  Honduras: {
    M: "RTN",
    F: "RTN",
  }, // Honduras
  Mexico: {
    M: "RFC",
    F: "RFC",
  }, // Mexico
  Nicaragua: {
    M: "RUC",
    F: "RUC",
  }, // Nicaragua
  Panama: {
    M: "RUC",
    F: "RUC",
  }, // Panama
  Paraguay: {
    M: "RUC",
    F: "RUC",
  }, // Paraguay
  Peru: {
    M: "RUC",
    F: "RUC",
  }, // Peru
  Spain: {
    M: "NIF",
    F: "NIF",
  }, // Spain
  "United States": {
    M: "TIN",
    F: "SSN",
  }, // United States
  Uruguay: {
    M: "RUT",
    F: "RUT",
  }, // Uruguay
  "Venezuela, Bolivarian Republic of": {
    M: "RIF",
    F: "RIF",
  }, // Venezuela, Bolivarian Republic of
};
